import Logo from '@assets/images/octopus-logo-anim.svg?react'
import type { FC } from 'react'

type Props = {
  className?: string
  size?: number
}

/**
 * Animated octopus logo, rendered as an inline SVG with a SMIL animation.
 * Inline on purpose: Safari does not animate SMIL through a `<use>` of a
 * sprite added after page load. Colour is `currentColor` — set it via CSS
 * `color` on the className. The `size` prop sets the square box in px; CSS
 * width/height on the className override it.
 */
export const OctopusLogo: FC<Props> = ({ className = '', size = 48 }) => (
  <Logo className={className} width={size} height={size} aria-hidden="true" />
)
